export const courseLearning = [
    {
        id: 1,
        courseTitle: "Flutter Development",
        courseImage: "../assets/images/flutter_training.jpeg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "Debugging Flutter Apps",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonVideoId: "VPvVD8t02U8",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
    },
    {
        id: 2,
        courseTitle: "iOS Development",
        courseImage: "../assets/images/ios_training.png",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "Getting Started with Swift",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonVideoId: "URtsnESYcPk",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
    },
    {
        id: 3,
        courseTitle: "React-Native Development",
        courseImage: "../assets/images/react_native_course.jpeg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "Deploying React-Native App",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonVideoId: "ZBCUegTZF7M",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 7,
        courseTitle: "Xamarin Development",
        courseImage: "../assets/images/xamarin_training_course.jpg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "Using Xamarin.Forms",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonVideoId: "oNIvnCNzAqU",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
]